import Form from "../form";
import FormBuilderModel from "../../../../common/models/tracked/formBuilderModel";
import Guid from "~/helpers/guid";
import {INavigableValidatableModel} from "../../../../common/interfaces/navigableValidationInterfaces";
import Validatable from "../../../../common/mixins/validatable";
import {StringHelper} from "../../../../common/helpers/stringHelper";
import FormDetailSeoValidation from "../../../../common/models/navigableValidations/formDetailSeoValidation";
import IRepo from "../../../../common/interfaces/repo";
import Repo from "../../../../common/state/modules/repo";

export default class FormDetailSeo extends Validatable(FormBuilderModel) implements INavigableValidatableModel<FormBuilderModel> {
  title: string;
  slug: string;
  meta_description: string;
  form: Form;

  static repo: IRepo<FormDetailSeo> = new Repo<FormDetailSeo>('formDetailSeos', FormDetailSeo);

  constructor(form: Form) {
    super();
    this.rootModel = form;
    this.parent = form;
    this.defineProperty('client_id', Guid.create());
  }

  //******************** VALIDATABLE ********************//
  _validation: FormDetailSeoValidation = new FormDetailSeoValidation(this);
  //******************** VALIDATABLE END ********************//

  getDisplayName(name: string, value?: any) {
    return `SEO ${StringHelper.capitalize(name.split('_').join(' '))}`;
  }

  get rootName() {
    return "seo";
  }

  get displayName() {
    return "SEO";
  }
}
